import { render } from "./CreateExtension.vue?vue&type=template&id=7bce60ba&scoped=true"
import script from "./CreateExtension.vue?vue&type=script&lang=js"
export * from "./CreateExtension.vue?vue&type=script&lang=js"

import "./CreateExtension.vue?vue&type=style&index=0&id=7bce60ba&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bce60ba"]])

export default __exports__